export default {
  photoWallName: '图片墙',
  logoWallName: 'Logo墙',
  brandWallName: '品牌墙',
  img: '图片',
  logo: 'Logo图',
  brandImg: '品牌图',
  view: '查看'
}
